<template>
    <div class="alert no-mobile" :class="obj.type" v-if="show"><span v-html="obj.msg"></span><i class="ico-clearclose close" @click="show = false"></i></div>

  
</template>
<script>
export default {
    name: "Alert",
    data(){
        return {
            show: true
        }
    },
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    mounted(){
        const TIMEOUT = (this.obj.timeout) ? this.obj.timeout : 10000
        setTimeout(() => {
            this.show = false
        },TIMEOUT)
    }
}
</script>
<style lang="scss" scoped>
    .alert{
        background: #1a291c;
        padding: 10px 10px 10px 20px;
        position: relative;
        max-width: 300px;
        /* width: 100%; */
        margin: 0 0 3px 0;
        right: 0;
        color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .close{
            padding: 10px;
            margin-left: 10px;
            cursor: pointer;
        }
        &.success{
            background: #20D1A3;
            border-left: 3px solid darken(#20d1a3, 20%); 
            .close{
                color: darken(#20d1a3, 20%);
            }
        }
        &.error{ 
            background: #F06C6C;
            border-left: 3px solid darken(#F06C6C, 20%);
            .close{
                color: darken(#F06C6C, 20%);
            }
        }
        
    }

   
</style>